/** "Tue 20 Oct 2026, 3:15 pm" in Australia/Sydney, or '' for a missing or bad
 *  timestamp. `withYear: false` drops the weekday and year, for recent things. */
export function formatSydneyDateTime(iso?: string | null, { withYear = true } = {}): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-AU', {
    timeZone: 'Australia/Sydney',
    ...(withYear ? { weekday: 'short', year: 'numeric' } : {}),
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit',
  });
}
